module.exports = "/_next/static/images/es_icon-48514806872de65fe9386873e5e825b0.svg";